import { Node, mergeAttributes } from '@tiptap/core'
import { Extension } from '@tiptap/core'
import { TextSelection, NodeSelection } from 'prosemirror-state'

export const InsertParagraphAfterMediaGroup = Extension.create({
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { state, view } = editor
        const { selection } = state
        const { $from } = selection

        const parentNode = $from.node($from.depth)

        // Check if we're inside or selecting a mediaGroup node
        if (parentNode?.type?.name === 'mediaGroup') {
          const { tr } = state
          const posAfter = $from.after($from.depth)

          const paragraph = state.schema.nodes.paragraph.create()

          tr.insert(posAfter, paragraph)

          // Move selection to new paragraph
          const resolvedPos = tr.doc.resolve(posAfter + 1)
          const newSelection = TextSelection.create(tr.doc, resolvedPos.pos)

          tr.setSelection(newSelection)
          view.dispatch(tr)
          return true
        }

        return false
      },
    }
  },
})

export const MediaGroup = Node.create({
  name: 'mediaGroup',
  group: 'block',
  content: 'resizableMedia resizableMedia? resizableMedia?', // up to 3 images
  defining: true,
  draggable: false,
  isolating: false,
  addAttributes() {
    return {
      layout: {
        default: 'row-3', // could support row-2 or other layouts later
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="media-group"]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'media-group',
        class: 'media-group',
        style: 'display: flex; gap: 8px; flex-wrap: wrap; max-width: 100%',
      }),
      0,
    ]
  },
})
